/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {DataTableParams} from '../../assets/design-library/data-table/index';

import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';


let headers: HttpHeaders = new HttpHeaders();


  function paramsToQueryString(params: DataTableParams) {
  let result = [];

  if (params.offset != null) {
      result.push(['page', Number(params.offset) / Number(params.limit)]);
  }
  if (params.limit != null) {
      result.push(['size', params.limit]);
  }
  if (params.sortBy != null) {
      result.push(['_sort', params.sortBy.toLowerCase()]);
  }
  if (params.sortAsc != null) {
      result.push(['_order', params.sortAsc ? 'ASC' : 'DESC']);
  }

  return result.map(param => param.join('=')).join('&');
}


@Injectable()
export class RemoteService {
  private BASE_URL;
  private Person_Url;
  constructor(private httpc: HttpClient) {
    this.BASE_URL = inject(APP_CONFIG).baseUrl + '/api/drivers';
    this.Person_Url = inject(APP_CONFIG).baseUrl + '/api/persons';


  }

  queryAll(params: DataTableParams): Observable<HttpResponse<any>> {
    return this.httpc.get(this.BASE_URL + '/search?' + paramsToQueryString(params), {
      headers: headers,
      responseType: 'json',
      observe: 'response'
    });

  }



  queryByNames($event, params: DataTableParams): Observable<HttpResponse<any>> {
    return this.httpc.get(this.BASE_URL + '/filterPage/' + $event + '?' + paramsToQueryString(params), {
      headers: headers,
        responseType: 'json',
        observe: 'response'
    });
  }

  queryByNamesToPersons($event, params: DataTableParams): Observable<HttpResponse<any>> {
    return this.httpc.get(this.Person_Url+"/filterPage/"  + $event + '?' + paramsToQueryString(params), {
      headers: headers,
      responseType: 'json',
      observe: 'response'
    });
  }


}
